module.exports = __webpack_public_path__ + "images/referenzen/socialmedia/rosenthal_kollektionsfilm.jpg";